/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/* document.addEventListener("DOMContentLoaded", function () {
  let currentPage = 1;
  let isLoading = false;
  const productContainer = document.querySelector('.product-list__inner');
  const loader = document.createElement('div');
  loader.id = 'infinite-scroll-loader';
  loader.style.textAlign = 'center';
  loader.style.padding = '20px';
  loader.textContent = '読み込み中...';
  productContainer.parentNode.appendChild(loader);

  // コレクションハンドルを取得
  const collectionHandle = window.location.pathname.split("/")[2];

  async function loadNextPage() {
    if (isLoading) return;
    isLoading = true;
    currentPage += 1;

    try {
      const response = await fetch(`/collections/${collectionHandle}?page=${currentPage}`);
      if (!response.ok) throw new Error('ページ取得エラー');

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newProductContainer = doc.querySelector('.product-list__inner');
      const newProducts = newProductContainer ? newProductContainer.children : [];

      if (newProducts.length === 0) {
        loader.textContent = "すべての商品を表示しました";
        window.removeEventListener('scroll', handleScroll);
        return;
      }

      for (let product of newProducts) {
        productContainer.appendChild(product.cloneNode(true));
      }

      isLoading = false;
    } catch (error) {
      console.error('読み込み失敗:', error);
      loader.textContent = "読み込みエラーが発生しました";
    }
  }

  function handleScroll() {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const bodyHeight = document.body.offsetHeight;

    if (scrollTop + windowHeight + 200 >= bodyHeight) {
      loadNextPage();
    }
  }

  window.addEventListener('scroll', handleScroll);
}); */

// 商品ページ product description
// => sections/o_product-contents.liquid
// ==================================================================================================== //
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const container = document.getElementById('product-description-feature-flickity');
    if (container && !container.classList.contains('swiper-initialized')) {
      // 最初に slide クラスを追加
      container.classList.add('slide');

      // 次にHTML構造を変換
      transformToSwiperStructure(container);
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function transformToSwiperStructure(container) {
    container.classList.add('slide');

    const featureUnits = Array.from(container.querySelectorAll('.feature_unit'));

    // 新しい構造のための要素を作成
    const slideGallery = document.createElement('div');
    slideGallery.classList.add('product-description-point');

    const swiperWrapper = document.createElement('div');
    swiperWrapper.classList.add('swiper-wrapper');

    featureUnits.forEach(unit => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      slide.appendChild(unit);
      swiperWrapper.appendChild(slide);
    });

    slideGallery.appendChild(swiperWrapper);

    // Swiperのページネーションとナビゲーションを追加
    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');

    const buttonPrev = document.createElement('button');
    buttonPrev.type = 'button';
    buttonPrev.classList.add('swiper-button-prev');

    const buttonNext = document.createElement('button');
    buttonNext.type = 'button';
    buttonNext.classList.add('swiper-button-next');

    slideGallery.appendChild(pagination);
    slideGallery.appendChild(buttonPrev);
    slideGallery.appendChild(buttonNext);

    // 元の要素をすべて削除して、slideGalleryを追加
    container.innerHTML = '';
    container.appendChild(slideGallery);

    container.classList.add('swiper-initialized'); // 再実行防止

    // Swiper 初期化（Swiper JSが読み込まれている前提）
    if (typeof Swiper !== 'undefined') {
      new Swiper('.product-description-point', {
        slidesPerView: 'auto',
        //slidesPerGroup: 3,
        loop: false,
        grabCursor: true,
        speed: 300,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          0: {
            spaceBetween: 12,
          },
          741: {
            spaceBetween: 40,
          },
        },
      });
    }
  }
});

/* (() => {
  const targetId = 'product-description-feature-flickity';

  const initializeFlickity = (el) => {
    if (el.dataset.flickityInitialized) return; // 二重初期化防止

    el.dataset.flickity = JSON.stringify({
      groupCells: true,
      autoPlay: true,
      adaptiveHeight: false,
      contain: true,
      pauseAutoPlayOnHover: true
    });
    el.classList.add('slide');

    // Flickityがグローバルにロード済なら即初期化
    if (typeof Flickity === 'function') {
      new Flickity(el);
    }

    el.dataset.flickityInitialized = 'true';
  };

  const observeAndInit = () => {
    // 既に存在していれば即実行
    const existing = document.getElementById(targetId);
    if (existing) initializeFlickity(existing);

    // DOMの変更を監視して、該当要素が出現したら初期化
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          const el = node.id === targetId
            ? node
            : node.querySelector(`#${targetId}`);

          if (el) {
            initializeFlickity(el);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAndInit);
  } else {
    observeAndInit();
  }
})(); */

/* document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('product-description-feature-flickity').setAttribute('data-flickity', '{ "groupCells": true, "autoPlay": true, "adaptiveHeight": false, "contain": true, "pauseAutoPlayOnHover": true }');
  document.getElementById('product-description-feature-flickity').classList.add('slide');
}); */

// 商品ページ：名入れメッセージ
// => snippets/c_product-form.liquid
// ==================================================================================================== //
/* document.addEventListener("DOMContentLoaded", function() {

  function initMessageForm() {
    const messageSelect = document.getElementById("product-form__naire__message");
    const wrapper = document.getElementById("product-form__naire__message_text_wrapper");

    if (!messageSelect || !wrapper) return; // 要素が無ければ何もしない

    const inputs = [
      document.getElementById("product-form__naire__message_line1"),
      document.getElementById("product-form__naire__message_line2"),
      document.getElementById("product-form__naire__message_line3"),
      document.getElementById("product-form__naire__message_line4"),
    ].filter(Boolean);

    if (inputs.length === 0) return;

    // 既にエラーメッセージが存在しない場合だけ追加
    let errorMessage = document.getElementById("naire-message-error");
    if (!errorMessage) {
      errorMessage = document.createElement("div");
      errorMessage.style.color = "#BB551F";
      errorMessage.style.marginTop = "8px";
      errorMessage.style.fontSize = "0.9em";
      errorMessage.id = "naire-message-error";
      wrapper.appendChild(errorMessage);
    }

    const originalNames = inputs.map(input => input.getAttribute("name"));

    // 初期処理: 一旦name削除
    inputs.forEach(input => input.removeAttribute("name"));

    // 入力許可文字 正規表現
    const allowedRegex = /^[ぁ-ん0-9０-９御祝寿贈慶!！☆ 　]*$/;

    function toggleMessageFields() {
      if (messageSelect.value === "希望する") {
        wrapper.style.display = "block";
        inputs.forEach((input, i) => {
          input.setAttribute("name", originalNames[i]);
          input.setAttribute("required", "required");
        });
      } else {
        wrapper.style.display = "none";
        inputs.forEach(input => {
          input.removeAttribute("name");
          input.removeAttribute("required");
        });
        errorMessage.textContent = "";
      }
    }

    function validateInputs() {
      let hasError = false;
      inputs.forEach(input => {
        if (input.value && !allowedRegex.test(input.value)) {
          hasError = true;
        }
      });
      errorMessage.textContent = hasError
        ? "※使用できない文字が含まれています。使用できる文字はひらがな、数字、一部の漢字（御・祝・寿・贈・慶）、一部の記号（「！」「・」「☆」）、全角スペースのみです。"
        : "";
    }

    // 既存イベントを重複しないように remove → add
    messageSelect.removeEventListener("change", toggleMessageFields);
    messageSelect.addEventListener("change", toggleMessageFields);

    inputs.forEach(input => {
      input.removeEventListener("input", validateInputs);
      input.addEventListener("input", validateInputs);
    });

    // 初期状態反映
    toggleMessageFields();
    validateInputs();
  }

  // 初回実行
  initMessageForm();

  // Shopifyセクションの再読み込みに対応
  document.addEventListener("shopify:section:load", initMessageForm);

  // その他: DOM変化を監視して再実行（必要に応じて）
  const observer = new MutationObserver(() => {
    initMessageForm();
  });
  observer.observe(document.body, { childList: true, subtree: true });

}); */


document.addEventListener("DOMContentLoaded", function() {
  const messageSelect = document.getElementById("product-form__naire__message");
  const wrapper = document.getElementById("product-form__naire__message_text_wrapper");
  const addToCartBtn = document.getElementById("AddToCart");

  if (!messageSelect || !wrapper || !addToCartBtn) return;

  const inputs = [
    document.getElementById("product-form__naire__message_line1"),
    document.getElementById("product-form__naire__message_line2"),
    document.getElementById("product-form__naire__message_line3"),
    document.getElementById("product-form__naire__message_line4")
  ].filter(Boolean);

  if (inputs.length === 0) return;

  // 元の name 属性を保存
  const originalNames = inputs.map(input => input.getAttribute("name"));

  // 初期状態は name 削除（toggle で復元）
  inputs.forEach(input => input.removeAttribute("name"));

  // エラーメッセージ要素
  let errorMessage = document.getElementById("naire-message-error");
  if (!errorMessage) {
    errorMessage = document.createElement("div");
    errorMessage.id = "naire-message-error";
    errorMessage.style.color = "#BB551F";
    errorMessage.style.marginTop = "8px";
    errorMessage.style.fontSize = "0.9em";
    wrapper.appendChild(errorMessage);
  }

  // 許可文字 正規表現
  // 20260127：数字、漢字は使用不可に変更
  // 20260903：漢字を復活（全漢字を許可。数字は引き続き不可）
  // const allowedRegex = /^[ぁ-ん0-9０-９御祝寿贈慶!！・☆ 　]*$/;
  // const allowedRegex = /^[ぁ-ん！・☆　]+$/;
  // \u4E00-\u9FFF = 漢字（CJK統合漢字）、々〆〇 = 繰り返し記号など
  const allowedRegex = /^[ぁ-ん\u4E00-\u9FFF々〆〇！・☆　]+$/;

  // 入力欄表示/非表示切替
  function toggleMessageFields() {
    if (messageSelect.value.trim() === "希望する") {
      wrapper.style.display = "block";
      inputs.forEach((input, i) => {
        input.setAttribute("name", originalNames[i]);
        input.setAttribute("required", "required");
      });
    } else {
      wrapper.style.display = "none";
      inputs.forEach(input => {
        input.removeAttribute("name");
        input.removeAttribute("required");
      });
      errorMessage.textContent = "";
      addToCartBtn.removeAttribute("disabled");
      addToCartBtn.classList.remove("button--ternary");
    }
  }

  // 文字置換関数
  function normalizeInput(value) {
    if (!value) return "";
    return value
      // 半角数字 → 全角数字
      //.replace(/[0-9]/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFF10 - 0x30))
      // 半角! → 全角！
      .replace(/!/g, "！")
      // 半角スペース → 全角スペース
      .replace(/ /g, "　");
  }

  // blur時の入力チェック
  function onBlurValidate(input) {
    // 文字置換
    input.value = normalizeInput(input.value);

    // バリデーション
    let hasError = false;
    inputs.forEach(input => {
      if (input.value && !allowedRegex.test(input.value)) {
        hasError = true;
      }
    });

    if (hasError) {
      errorMessage.textContent =
        "※使用できない文字が含まれています。使用できる文字はひらがな、漢字、一部の全角記号（「！」「・」「☆」）、全角スペースのみです。";
      addToCartBtn.setAttribute("disabled", "disabled"); // ボタン無効化
      addToCartBtn.classList.add("button--ternary");
    } else {
      errorMessage.textContent = "";
      addToCartBtn.removeAttribute("disabled"); // ボタン有効化
      addToCartBtn.classList.remove("button--ternary");
    }
  }

  // イベント設定
  messageSelect.addEventListener("change", toggleMessageFields);
  inputs.forEach(input => input.addEventListener("blur", () => onBlurValidate(input)));

  // 初期状態反映
  toggleMessageFields();
});


// Judge.me
// => テキスト書き換え
// ==================================================================================================== //
(function () {
  var PATCHES = [
    { sel: '.jdgm-write-review-modal__checkbox-text',
      text: 'ニックネームは掲載せず「匿名希望」として投稿する' },

    { sel: '#jdgm-name-help',
      text: '※ご入力いただいたニックネームはサイト上には掲載されません。' },

    { sel: '#jdgm-email-help',
      text: '※特典プレゼントにご応募の方は、必ずご注文時にご入力いただいたメールアドレスをご入力ください。異なるメールアドレスを入力されますと、ご本人様の照合ができず、ご応募が無効となる場合がございます。' },

    // 最終ステップの送信ボタン（「投稿する」のときだけ置換）
    { sel: '.jdgm-write-review-modal__nav-btn-next',
      from: '投稿する',
      text: 'この内容で送信する' },

    { sel: '.jdgm-write-review-modal__gdpr-statement',
      html: 'ご記入いただいたレビューについて、必要な場合にのみご連絡させていただく場合がございます。<br>'
          + 'レビューを送信することで、当レビューシステム「Judge.me」の'
          + '<a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">利用規約</a>、'
          + '<a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">プライバシーポリシー</a>、'
          + '<a href="https://judge.me/content-policy" target="_blank" rel="nofollow noopener">コンテンツポリシー</a>及び'
          + '当サイトの<a href="/policies/terms-of-service" target="_blank" rel="nofollow noopener">利用規約</a>、'
          + '<a href="/policies/privacy-policy" target="_blank" rel="nofollow noopener">プライバシーポリシー</a>'
          + 'に同意したことになります。' }
  ];

  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }

  function apply() {
    PATCHES.forEach(function (p) {
      document.querySelectorAll(p.sel).forEach(function (el) {
        if (p.html != null) {
          if (norm(el.innerHTML) === norm(p.html)) return;  // 適用済み
          el.innerHTML = p.html;
        } else {
          var cur = norm(el.textContent);
          if (cur === norm(p.text)) return;                  // 適用済み
          if (p.from != null && cur !== norm(p.from)) return; // 対象外の文言（「次へ」など）
          el.textContent = p.text;
        }
      });
    });
  }

  apply();
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
})();
/* document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver((mutations, obs) => {
    const target = document.querySelector('.jdgm-form__fieldset-actions');
    if (target) {
      // 追加する要素を作成
      const infoDiv = document.createElement('div');
      infoDiv.className = 'jdgm-form__fieldset';
      infoDiv.innerHTML = `
        <div>
          <p>
            データの利用方法について：ご記入いただいたレビューについてのみ、必要な場合にのみご連絡させていただく場合がございます。
            レビューを送信することで、当レビューシステム「Judge.me」の
            <a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">利用規約</a>、
            <a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">プライバシーポリシー</a>、
            <a href="https://judge.me/content-policy" target="_blank" rel="nofollow noopener">コンテンツポリシー</a>及び
            当サイトの<a href="/policies/terms-of-service" target="_blank" rel="nofollow noopener">利用規約</a>、
            <a href="/policies/privacy-policy" target="_blank" rel="nofollow noopener">プライバシーポリシー</a>
            に同意したことになります。
          </p>
        </div>
      `;

      // 対象要素の前に追加
      target.parentNode.insertBefore(infoDiv, target);

      // 監視終了
      obs.disconnect();
    }
  });

  // body以下の変化を監視（必要に応じてセレクタを絞ってもOK）
  observer.observe(document.body, { childList: true, subtree: true });

  // ========================================
  // 送信ボタンのテキスト書き換え
  // ========================================
  setInterval(() => {
    const sharePage = document.querySelector(
      //".jdgm-write-review-modal__page--share-media.current-page"
      ".jdgm-write-review-modal__page--custom-questions.current-page"
    );
    const nextBtn = document.querySelector(
      ".jdgm-write-review-modal__nav-btn.jdgm-write-review-modal__nav-btn-next"
    );
  
    if (nextBtn) {
      if (sharePage) {
        nextBtn.textContent = "送信する";
      } else {
        nextBtn.textContent = "次へ";
      }
    }
  }, 500);
}); */

// セレクトアプリ スムーススクロール
// => /pages/hina-select
// => /pages/gogatsu-select
// ==================================================================================================== //
document.addEventListener("DOMContentLoaded", function () {
  const stepControl = document.getElementById("stepControl");
  const scrollTarget = document.getElementById("cisScreen");
  const header = document.querySelector(".header");

  stepControl.addEventListener("click", function (e) {
    const target = e.target.closest(".prev, .next");

    if (target && scrollTarget && window.innerWidth <= 740) {
      const headerHeight = header ? header.offsetHeight : 0;
      const targetY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - headerHeight - 30;

      window.scrollTo({
        top: targetY,
        behavior: "smooth"
      });
    }
  });
});

// o-Slide Banner
// => /sections/o_slide-banner.liquid
// ==================================================================================================== //
document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".slide-banner", {
    centeredSlides: true,
    slidesPerView: 'auto',
    grabCursor: true,
    speed: 300,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        spaceBetween: 12,
      },
      741: {
        spaceBetween: 40,
      },
    },
  });
});

// o-Slide gallery
// => /sections/o_slide-gallery.liquid
// ==================================================================================================== //
document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".slide-gallery", {
    centeredSlides: true,
    autoHeight: true,
    loop: false,
    slidesPerView: '1',
    grabCursor: true,
    speed: 300,
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        spaceBetween: 12,
      },
      741: {
        spaceBetween: 40,
      },
    },
  });
});

// o-Infinite Slide
// => /sections/o_infinite-slide.liquid
// ==================================================================================================== //
function initInfiniteSlider({
  containerSelector = '.infinite-slider',
  trackSelector = '.infinite-slider-track',
  itemSelector = '.infinite-slider-item',
  scrollSpeed = 15 // 秒
} = {}) {
  const infiniteSlider = document.querySelector(containerSelector);
  const sliderTrack = infiniteSlider?.querySelector(trackSelector);

  if (!infiniteSlider || !sliderTrack) return;

  // アニメーション速度を動的に設定
  sliderTrack.style.animationDuration = `${scrollSpeed}s`;

  // アイテム複製（無限ループのため）
  const sliderItems = sliderTrack.querySelectorAll(itemSelector);
  sliderItems.forEach(item => {
    const clone = item.cloneNode(true);
    sliderTrack.appendChild(clone);
  });

  let isPaused = false;

  // PC: マウスオーバーで停止
  infiniteSlider.addEventListener('mouseenter', () => {
    sliderTrack.style.animationPlayState = 'paused';
    isPaused = true;
  });

  infiniteSlider.addEventListener('mouseleave', () => {
    sliderTrack.style.animationPlayState = 'running';
    isPaused = false;
  });

  // スマホ: タップで停止・再開
  infiniteSlider.addEventListener('touchstart', () => {
    isPaused = !isPaused;
    sliderTrack.style.animationPlayState = isPaused ? 'paused' : 'running';
  });
}

initInfiniteSlider({
  containerSelector: '.infinite-slider',
  trackSelector: '.infinite-slider-track',
  itemSelector: '.infinite-slider-item',
  scrollSpeed: 40
});

// o-Product contents
// => /snippets/o_product-contents.liquid
// 商品説明
// ==================================================================================================== //
document.addEventListener("DOMContentLoaded", () => {
  // 旧テンプレート判別用class追加
  // -------------------------------------------------- //
  document.querySelectorAll(".product-description").forEach(desc => {
    if (desc.querySelector(".product-description-index")) {
      desc.classList.add("is-2025ver");
    } else {
      desc.classList.add("is-legacy");
    }
  });

  // ---------- DOM lookups (defensive) ----------
  var indexRoot = document.querySelector('.product-description-index');
  var featureRoot = document.querySelector('.product-description-feature');
  var featureUnits = featureRoot ? featureRoot.querySelectorAll(':scope > .feature_unit') : null;

  if (!indexRoot || !featureRoot || !featureUnits || featureUnits.length === 0) {
    // If we cannot find essential nodes or there are no features, only try to zero the count and exit safely.
    var countElFallback = indexRoot ? indexRoot.querySelector('.content .header #count') : null;
    if (countElFallback) countElFallback.textContent = '0';
    return;
  }
  
  // 売りポイントの要素にアンカーリンク用id付与
  // -------------------------------------------------- //
  featureUnits.forEach(function (unit, i) {
    var id = 'feature' + String(i + 1).padStart(2, '0');
    unit.id = id;
    if (!unit.hasAttribute('tabindex')) unit.setAttribute('tabindex', '-1'); // for focus after scroll
  });
  
  // 売りポイントの数カウント
  // -------------------------------------------------- //
  var countEl = indexRoot.querySelector('.content .header #count');
  if (countEl) {
    countEl.textContent = String(featureUnits.length);
  }

  // 売りポイントが1つ以上あれば目次作成
  // -------------------------------------------------- //
  var existingBody = indexRoot.querySelector(':scope > .body');
  var indexBody = existingBody;
  if (!existingBody) {
    indexBody = document.createElement('div');
    indexBody.className = 'body';
    // A11y: this is a navigation list for the feature sections
    indexBody.setAttribute('role', 'navigation');
    indexBody.setAttribute('aria-label', 'feature-index');
    indexRoot.querySelector('.content').appendChild(indexBody);
  }
  var indexUl = indexBody.querySelector('ul');
  if (!indexUl) {
    indexUl = document.createElement('ul');
    indexBody.appendChild(indexUl);
  }

  // ---------- Rules for generating <li> labels based on img filenames and/or header text ----------
  // Priority order: first match wins.
  var RULES = [
    {
      fileIncludes: '_uri',
      textIncludes: '裾',
      labelParts: [{ text: '生地を贅沢に使用した' }, { em: 'お衣装' }]
    },
    {
      fileIncludes: 'craft',
      textIncludes: '手仕事',
      labelParts: [{ text: '熟練の職人が生み出す' }, { em: '本物品質' }]
    },
    {
      fileIncludes: 'wood',
      textIncludes: '質感',
      labelParts: [{ text: 'ぬくもりのある' }, { em: '天然木' }, { text: 'を使用' }]
    },
    {
      fileIncludes: 'edutoy',
      textIncludes: '遊べる',
      labelParts: [{ text: 'お子さまと一緒に' }, { em: '遊べる' }]
    },
    {
      fileIncludes: 'japan',
      textIncludes: '国内生産',
      labelParts: [{ text: '安心・安全の' }, { em: '日本製' }]
    },
    {
      fileIncludes: 'size',
      textIncludes: 'サイズ',
      labelParts: [{ text: 'どこでも飾れる' }, { em: 'コンパクトサイズ' }]
    },
    {
      fileIncludes: 'design',
      textIncludes: 'デザイン',
      labelParts: [{ text: 'インテリアに馴染む' }, { em: 'デザイン' }]
    },
    {
      fileIncludes: '2way',
      textIncludes: '2通り',
      labelParts: [{ em: '壁掛け' }, { text: 'も' }, { em: '平置き' }, { text: 'もできる2WAY仕様' }]
    },
    {
      fileIncludes: 'horse',
      textIncludes: '馬',
      labelParts: [{ em: '“富、繁栄、安泰”' }, { text: 'をもたらす馬飾り' }]
    }
  ];

  function extractFilenames(unit) {
    var imgs = unit.querySelectorAll('.image img[src]');
    var names = [];
    imgs.forEach(function (img) {
      var src = img.getAttribute('src') || '';
      var filename = src.split('/').pop() || '';
      names.push(filename.toLowerCase());
    });
    return names;
  }

  function extractHeaderText(unit) {
    var h3 = unit.querySelector('.content .header h3');
    var text = h3 ? h3.textContent : '';
    return (text || '').trim();
  }

  function findRuleMatch(fileNames, headerText) {
    var headerLower = headerText.toLowerCase();
    for (var i = 0; i < RULES.length; i++) {
      var r = RULES[i];
      var fileHit = r.fileIncludes && fileNames.some(function (n) { return n.indexOf(r.fileIncludes) !== -1; });
      var textHit = r.textIncludes && headerText.indexOf(r.textIncludes) !== -1; // JP keyword is case-sensitive
      // Fallback to case-insensitive for ASCII like "2WAY"
      if (!textHit && r.textIncludes && /[a-z0-9]/i.test(r.textIncludes)) {
        textHit = headerLower.indexOf(r.textIncludes.toLowerCase()) !== -1;
      }
      if (fileHit || textHit) return r;
    }
    return null;
  }

  function createTOCItem(targetId, labelParts) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.setAttribute('href', '#' + targetId);
    a.setAttribute('aria-describedby', targetId);

    labelParts.forEach(function (part) {
      if (part.text) {
        a.appendChild(document.createTextNode(part.text));
      } else if (part.em) {
        var emEl = document.createElement('em');
        emEl.appendChild(document.createTextNode(part.em));
        a.appendChild(emEl);
      }
    });

    li.appendChild(a);
    return li;
  }

  // Build a set to avoid duplicate hrefs (in case script runs twice)
  var existingHrefSet = new Set();
  indexUl.querySelectorAll('a[href^="#"]').forEach(function (a) {
    existingHrefSet.add(a.getAttribute('href') || '');
  });

  featureUnits.forEach(function (unit) {
    var rule = findRuleMatch(extractFilenames(unit), extractHeaderText(unit));
    if (!rule) return;
    
    // feature_unitにクラス付与
    if (rule.fileIncludes) {
      unit.classList.add(rule.fileIncludes);
    }

    var href = '#' + unit.id;
    if (existingHrefSet.has(href)) return;

    var li = createTOCItem(unit.id, rule.labelParts);
    indexUl.appendChild(li);
    existingHrefSet.add(href);
  });

  // ページ内リンクのスムースクロール
  // -------------------------------------------------- //
  function getElementHeight(sel) {
    var el = document.querySelector(sel);
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    return rect.height || 0;
  }

  function getScrollOffset() {
    var headerH = getElementHeight('.shopify-section--header');
    if (window.innerWidth >= 1000) {
      var stickyH = getElementHeight('.product-sticky-form');
      return headerH + stickyH;
    }
    return headerH;
  }

  function smoothScrollTo(target) {
    if (!target) return;
    var offset = getScrollOffset();
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth'
    });

    // Move focus after a short delay to allow scroll completion
    window.setTimeout(function () {
      target.focus({ preventScroll: true });
      // Sync hash without jumping
      var id = target.id;
      if (id && history && history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    }, 250);
  }

  // Delegate clicks from any <a> within .product-description-index
  indexRoot.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    var id = anchor.getAttribute('href').slice(1);
    if (!id) return;

    var target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    smoothScrollTo(target);
  });

  // 商品こだわり詳細画像 無限スクロールスライダー
  // -------------------------------------------------- //
  (function(){
    const container = document.querySelector('.product-description-details_image');
    if(!container) return;
  
    if(container.dataset.sliderInited === "1") return; // 二重初期化防止
    container.dataset.sliderInited = "1";
  
    const track = container.querySelector('.image');
    if(!track) return;
  
    // ===== 無限ループ用に複製 =====
    if(!track.dataset.cloned){
      const items = Array.from(track.children);
      items.forEach(el => track.appendChild(el.cloneNode(true)));
      track.dataset.cloned = "1";
    }
  
    let offset = 0;
    let baseSpeed = 0.75;
    let dynamicSpeed = baseSpeed;
    let isPaused = false;
    let rafId;
    let resumeTimer;
  
    function autoScroll(){
      if(!isPaused){
        offset += dynamicSpeed;
        if(offset >= track.scrollWidth / 2) offset = 0;
        track.style.transform = `translateX(-${offset}px)`;
      }
      rafId = requestAnimationFrame(autoScroll);
    }
    autoScroll();
  
    // ===== タップ / クリックで一時停止 =====
    let pointerDown = false;
    let startX = 0, startY = 0, startTime = 0;
    const TAP_MAX_MOVE = 8;
    const TAP_MAX_TIME = 300;
    let lastTapAt = 0;
  
    container.addEventListener('pointerdown', (e)=>{
      pointerDown = true;
      startX = e.clientX;
      startY = e.clientY;
      startTime = performance.now();
    });
  
    container.addEventListener('pointerup', (e)=>{
      if(!pointerDown) return;
      pointerDown = false;
  
      const dx = Math.abs(e.clientX - startX);
      const dy = Math.abs(e.clientY - startY);
      const dt = performance.now() - startTime;
      const isTap = dx < TAP_MAX_MOVE && dy < TAP_MAX_MOVE && dt < TAP_MAX_TIME;
  
      if(isTap){
        isPaused = !isPaused;
        container.classList.toggle('is-paused', isPaused);
        clearTimeout(resumeTimer);
        lastTapAt = performance.now();
      }
    });
  
    container.addEventListener('click', (e)=>{
      if(performance.now() - lastTapAt < 350){
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  
    // ===== スマホ スワイプ =====
    if("ontouchstart" in window){
      let isTouchDragging = false;
      let touchStartX = 0;
      let scrollStartOffset = 0;
  
      container.addEventListener('touchstart', (e)=>{
        if(e.touches.length !== 1) return;
        const touch = e.touches[0];
        isTouchDragging = true;
        touchStartX = touch.clientX;
        scrollStartOffset = offset;
  
        pauseAndResume();
      }, {passive:true});
  
      container.addEventListener('touchmove', (e)=>{
        if(!isTouchDragging) return;
        const touch = e.touches[0];
        const dx = touch.clientX - touchStartX;
        offset = scrollStartOffset - dx;
        track.style.transform = `translateX(-${offset}px)`;
      }, {passive:true});
  
      container.addEventListener('touchend', ()=>{
        if(!isTouchDragging) return;
        isTouchDragging = false;
        pauseAndResume(2000);
      });
    } else {
      // ===== デスクトップ マウス位置で速度調整 =====
      let isMouseInside = false;
  
      container.addEventListener('mouseenter', ()=>{ isMouseInside = true; });
      container.addEventListener('mouseleave', ()=>{
        isMouseInside = false;
        dynamicSpeed = baseSpeed;
      });
  
      container.addEventListener('mousemove', (e)=>{
        if(!isMouseInside) return;
        const rect = container.getBoundingClientRect();
        const mid = rect.left + rect.width / 2;
        let ratio = (e.clientX - mid) / (rect.width / 2);
        if(ratio > 1) ratio = 1;
        if(ratio < -1) ratio = -1;
  
        const maxExtra = 3;
        dynamicSpeed = baseSpeed + maxExtra * Math.abs(ratio);
        if(ratio < 0) dynamicSpeed *= -1;
      });
    }
  
    // ===== 一時停止後に自動再開 =====
    function pauseAndResume(delay = 2000){
      isPaused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(()=>{ isPaused = false; }, delay);
    }
  })();
});


  // ==================================================================================================== //
  // 技法プロセス 横スクロールカルーセル（PC：はみ出す場合のみ左右ナビ表示）
  // ==================================================================================================== //
  (function(){
    const tracks = document.querySelectorAll('.product-description-gihou-process .process');
    if(!tracks.length) return;

    // 前へ・次へボタンを生成
    const createNav = (dir, label)=>{
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `process-nav is-${dir}`;
      button.setAttribute('aria-label', label);
      return button;
    };

    tracks.forEach((track)=>{
      // .process を .process-slider で包み、左右にボタンを挿入
      const slider = document.createElement('div');
      slider.className = 'process-slider';
      track.parentNode.insertBefore(slider, track);
      const prev = createNav('prev', '前へ');
      const next = createNav('next', '次へ');
      slider.append(prev, track, next);

      // 1枚分（カード幅＋gap）のスクロール量
      const getStep = ()=>{
        const item = track.firstElementChild;
        if(!item) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      };

      const update = ()=>{
        const maxScroll = track.scrollWidth - track.clientWidth;
        slider.classList.toggle('is-overflow', maxScroll > 1);
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScroll - 1;
      };

      prev.addEventListener('click', ()=>{
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', ()=>{
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      // ===== PC マウスドラッグ =====
      const DRAG_THRESHOLD = 5;
      let isDown = false;
      let isDragged = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let snapTimer;

      track.addEventListener('pointerdown', (e)=>{
        if(e.pointerType !== 'mouse' || e.button !== 0) return;
        isDown = true;
        isDragged = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        clearTimeout(snapTimer);
      });

      track.addEventListener('pointermove', (e)=>{
        if(!isDown) return;
        const dx = e.clientX - dragStartX;
        if(!isDragged){
          if(Math.abs(dx) < DRAG_THRESHOLD) return;
          isDragged = true;
          track.setPointerCapture(e.pointerId);
          slider.classList.add('is-dragging');
        }
        track.scrollLeft = dragStartScroll - dx;
      });

      const endDrag = (e)=>{
        if(!isDown) return;
        isDown = false;
        if(!isDragged) return;
        if(track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);

        // ドラッグ方向に1枚分スナップ
        const step = getStep();
        const moved = track.scrollLeft - dragStartScroll;
        const base = Math.round(dragStartScroll / step);
        const count = Math.round(moved / step) || (Math.abs(moved) > step * 0.15 ? Math.sign(moved) : 0);
        track.scrollTo({ left: (base + count) * step, behavior: 'smooth' });

        // スムーズスクロール完了後にスナップを戻す
        snapTimer = setTimeout(()=>{ slider.classList.remove('is-dragging'); }, 500);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // ドラッグ後のクリック・画像のネイティブドラッグを無効化
      track.addEventListener('click', (e)=>{
        if(isDragged){
          e.preventDefault();
          e.stopPropagation();
          isDragged = false;
        }
      }, true);
      track.addEventListener('dragstart', (e)=>{ e.preventDefault(); });

      track.addEventListener('scroll', update, { passive: true });
      if('ResizeObserver' in window){
        new ResizeObserver(update).observe(track);
      } else {
        window.addEventListener('resize', update);
      }
      update();
    });
  })();
